import { VALIDATE_MASQUERADE } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

export interface MasqueradeResponse extends BaseAsyncReducerState {
    token?: string | undefined;
    tip?: string | undefined;
    tip2?: string | undefined;
    exp?: string | undefined;
    user_profile_id?: string | undefined;
    message?: string;
    email?: string;
    success: boolean;
    is_agent?: boolean;
}

// Define an initial state value for the app
const initialState: MasqueradeResponse = {
    success: false,
    loading: false,
    error: false,

}
  
function getMasqueradeReducer(state = initialState, action: AppAction) {

    const { payload } = action;

    switch (action.type) {
        case VALIDATE_MASQUERADE.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }

        case VALIDATE_MASQUERADE.SUCCESS:

            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false,

            }

        case VALIDATE_MASQUERADE.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default getMasqueradeReducer;